import TimePicker from './TimePicker';
import { ensureEndWithin24Hours } from '#datetime';
import { IsoTimestamp } from '#datetime';
import { TimeIcon } from '#icons';
import { Stack } from '@mui/material';

type Props = {
  /** Whether or not this is being rendered on mobile screen sizes */
  isMobile?: boolean;
  /**
   * Default time to initialize the date time picker.
   */
  value: { start: IsoTimestamp; end: IsoTimestamp };

  timezone: string;

  coalesceTimeUpdates?: boolean;

  dataTestId?: string;

  onChange: (start: IsoTimestamp, end: IsoTimestamp) => void;

  hideClockIcons?: boolean;

  disabled?: boolean;
};

const TimeRangePicker = ({
  //   isMobile,
  value: { start, end },
  timezone,
  dataTestId,
  onChange,
  hideClockIcons,
  disabled,
}: Props) => {
  const handleStartAtChange = (inputStart: IsoTimestamp) => {
    const { start: newStart, end: newEnd } = ensureEndWithin24Hours(inputStart, end);
    onChange(newStart, newEnd);
  };

  const handleEndAtChange = (inputEnd: IsoTimestamp) => {
    const { start: newStart, end: newEnd } = ensureEndWithin24Hours(start, inputEnd);
    onChange(newStart, newEnd);
  };

  return (
    <Stack direction="row" spacing={1} data-testid={dataTestId} flexGrow={1}>
      <TimePicker
        disabled={disabled}
        time={start}
        timezone={timezone}
        startAdornment={hideClockIcons ? undefined : <TimeIcon />}
        onChange={handleStartAtChange}
      />
      <TimePicker
        disabled={disabled}
        time={end}
        timezone={timezone}
        startAdornment={hideClockIcons ? undefined : <TimeIcon />}
        onChange={handleEndAtChange}
      />
    </Stack>
  );
};

export default TimeRangePicker;
